import Image from "next/image";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import { IconArrowRight } from "@tabler/icons-react";

interface CaseStudyContentProps {
    title: string;
    description: string;
    logo?: string;
    project_owner?: string;
    caseStudyId?: string;
}

function truncateWords(text: string, wordLimit: number): string {
    if (!text) return "";
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
}

export default function CaseStudyContent({ title, description, logo, project_owner, caseStudyId }: CaseStudyContentProps) {
    const t = useTranslations('caseStudies');
    
    return (
        <div className="w-full relative h-full text-white">
            <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold">{title}</p>
            <div className="pt-6 sm:pt-8 md:pt-10">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed mb-6 text-gray-300">
                    {truncateWords(description, 50)}
                </p>
                {caseStudyId && (
                    <Link 
                        href={`/case-studies/${caseStudyId}`}
                        className="border border-white/30 rounded-[10px] inline-flex items-center px-6 py-2.5 text-sm font-medium text-white hover:bg-white hover:text-black transition-all group mt-4 mb-8"
                    >
                        {t('readCaseStudy')}
                        <IconArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                )}
            </div>
            <div className="flex items-center gap-4 mt-2">
                {logo && <Image src={logo} width={180} height={180} className="w-[50px] h-[50px] object-contain" alt={"usecase"} />}
                {project_owner && <p className="text-gray-500">{project_owner}</p>}
            </div>
        </div>
    );
}
